
(function($, window){

    // On document ready
    $(function(){
        
    });
    

    $('.wpcf7-select').change(function(){
        let dd = $(this);
        if (dd.val()) {
            dd.addClass('touched');
        }
        else {
            dd.removeClass('touched');
        }
    });


    // Enquiries form in footer

    let footerForm = $('#site-footer').find('.enquiry-form');
    let footerFormButton = $('#site-footer').find('.enquiries.button');

    footerFormButton.click(e => {
        e.preventDefault();
        footerForm.slideDown({
            duration: 200,
            start: function() {
                $(this).css({
                    display: "flex"
                })
            },
            complete: function() {
                footerForm.find('.first_name').focus();
            }
        });
        footerFormButton.slideUp({
            duration: 10
        });

        gsap.to(window, {
            delay: 0.2,
            duration: 0.3, 
            scrollTo: '#site-footer',
            ease: "power3.out"
        });
    });

    footerForm.find('a.close').click(e => {
        e.preventDefault();
        footerForm.slideUp({
            duration: 200
        });
        footerFormButton.slideDown({
            duration: 200
        });
    });
})(jQuery, window);
